const Icon = ( { className }: { className?: string } ) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            className={className}
        >
            <circle cx="16" cy="16" r="16" fill="#265CFF" fillOpacity="0.15" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.584 8.45242C23.4219 8.10226 23.9312 8.45301 23.5479 9.41727C23.2955 10.0514 21.9224 13.2597 19.4287 19.0423C19.4257 19.0532 19.352 19.3122 19.0459 19.4251C12.5731 22.1889 12.4033 22.281 9.41992 23.5442C8.45647 23.9437 8.10088 23.4159 8.45605 22.5804C9.74723 19.5808 11.1239 16.3657 12.584 12.9358C12.6817 12.7067 12.9675 12.5681 12.9697 12.5667L22.584 8.45242ZM16 14.5989C15.2554 14.5989 14.6759 15.1333 14.6064 15.8538L14.5986 16.0003C14.5988 16.7942 15.2061 17.4006 16 17.4007C16.1848 17.404 16.3686 17.3702 16.54 17.3011C16.7114 17.2319 16.8673 17.129 16.998 16.9983C17.1288 16.8677 17.2315 16.7117 17.3008 16.5403C17.37 16.369 17.4046 16.1851 17.4014 16.0003C17.4048 15.8155 17.3709 15.6317 17.3018 15.4602C17.2326 15.2887 17.1288 15.1331 16.998 15.0022C16.8673 14.8714 16.7115 14.7678 16.54 14.6985C16.3686 14.6293 16.1849 14.5955 16 14.5989Z"
                fill="#0363F1"
            />
        </svg>
    );
};
function SourceRect( props: { originLink?: string } ) {
    if ( !props.originLink ) {
        return null;
    }
    // originLink
    return (
        <div className="border-stroke bg-surface-card mt-2  rounded-lg p-3 flex w-full border h-[62px] items-center gap-2">
            <Icon className="size-8 flex-shrink-0"></Icon>
            <div className="flex-1 min-w-0">
                <div className="text-t3 text-sm font-medium capitalize">Resolution Source</div>
                <a
                    href={props.originLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#265CFF] text-sm block font-medium truncate mt-1"
                >
                    {props.originLink}
                </a>
            </div>
        </div>
    );
}

export default SourceRect;
